import React, { useState } from 'react';
import PasswordStrengthBar from 'react-password-strength-bar';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import InputField from '../../_common/Form/TextFields/InputField';
import Button from '../../_common/Form/Buttons/Button';
import classes from '../Login/login.module.scss';
import SortpakLogo from '../../../assets/icons/sortpak-logo.png';
import { changePasswordRequest, logout } from '../../../store/actions/auth';
import accountHelpers from '../../../utils/accountHelpers';

const ChangePassword = ({ setPassword }) => {
  const dispatch = useDispatch();
  const { userId, token } = useParams();

  const [passwordData, setPasswordData] = useState({
    oldPassword: '',
    password: '',
    confirmpw: '',
  });

  const {
    oldPassword, password, confirmpw,
  } = passwordData;

  const [passwordStrength, setPasswordStrength] = useState('');

  const [error, setError] = useState('');

  const [requiredError, setRequiredError] = useState({
    oldPassword: false,
    password: false,
    confirmpw: false,
  });

  const [loading, setLoading] = useState(false);

  const changeData = (path, value) => {
    setPasswordData((prev) => ({ ...prev, [path]: value }));
    setRequiredError((prev) => ({ ...prev, [path]: false }));
    setError('');
  };

  const submitChangePassword = async (e) => {
    e.preventDefault();

    const sendData = { ...passwordData };

    sendData.userId = userId || accountHelpers.getUser()?.id;

    if (setPassword) {
      delete sendData.oldPassword;
      sendData.token = token;
    }

    if ((!setPassword && !oldPassword) || !password || !confirmpw) {
      _.forEach(sendData, (val, key) => {
        if (!val) setRequiredError((prev) => ({ ...prev, [key]: true }));
      });

      setError('Please fill this fields');

      return;
    }

    if (passwordStrength <= 1) {
      setError('Password is too week');
      setRequiredError((prev) => ({ ...prev, password: true }));

      return;
    }

    if (password !== confirmpw) {
      setError('Passwords do not match');
      setRequiredError((prev) => ({ ...prev, confirmpw: true }));

      return;
    }

    setLoading(true);

    const { payload, status } = await dispatch(changePasswordRequest({ ...sendData }));

    if (status === 'ok') {
      localStorage.setItem('successMsg', `Password successfully ${setPassword ? 'added' : 'changed'}`);

      logout();
    } else if (payload?.data?.message) {
      setError(payload.data.message);
    } else {
      setError(`Password ${setPassword ? 'add' : 'change'} failed`);
    }

    setLoading(false);
  };

  return (
    <div className={classes.wrapper}>
      <div className={classes.login_block}>
        <img alt="SortPak" src={SortpakLogo} className={classes.icon} />

        <h2 className={classes.title}>{setPassword ? 'Set New Password' : 'Change Password'}</h2>

        <form onSubmit={submitChangePassword}>
          <div className={classes.inputs_wrapper}>
            {!setPassword && (
              <InputField
                label="Old password"
                type="password"
                value={oldPassword}
                onChange={(value) => changeData('oldPassword', value)}
                error={requiredError.oldPassword}
              />
            )}

            <div>
              <InputField
                label="Password"
                value={password}
                type="password"
                onChange={(value) => changeData('password', value)}
                error={requiredError.password}
              />

              {password && (
                <PasswordStrengthBar
                  className={classes.password_strength_bar}
                  onChangeScore={setPasswordStrength}
                  password={password}
                  minLength={8}
                />
              )}
            </div>

            <InputField
              label="Confirm password"
              type="password"
              value={confirmpw}
              className="w-100"
              onChange={(value) => changeData('confirmpw', value)}
              error={requiredError.confirmpw}
            />

            {error && <div className={classes.error}>{error}</div>}
          </div>

          <Button
            title="Confirm"
            className={classes.btn}
            type="submit"
            loading={loading}
          />
        </form>
      </div>
    </div>
  );
};
ChangePassword.propTypes = {
  setPassword: PropTypes.bool,
};

ChangePassword.defaultProps = {
  setPassword: false,
};

export default ChangePassword;

// class ChangePassword extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       oldPassword: '',
//       password: '',
//       passStrength: null,
//       confirmpw: '',
//       error: this.props.error,
//     };
//
//     this.handleSubmit = this.handleSubmit.bind(this);
//   }
//
//   handleSubmit(event) {
//     event.preventDefault();
//     const user = accountHelpers.getUser();
//     const userId = user.id;
//     const { oldPassword, password, passStrength, confirmpw } = this.state;
//
//     if (!oldPassword) {
//       setError(Old password is required.' });
//     } else if (!password) {
//       setError(New password is required.' });
//     } else if (passStrength <= 1) {
//       setError(Password is too week' });
//     } else if (password !== confirmpw) {
//       setError(Passwords do not match.' });
//     } else {
//       axios
//         .post(
//           '/api/account/chpass',
//           { userId, oldPassword, password, confirmpw },
//           { headers: { Authorization: `Bearer ${accountHelpers.getToken()}` } },
//         )
//         .then((resp) => {
//           if (resp.data && resp.data.message) {
//             setError(esp.data.message });
//           } else if (resp.data && resp.data.success) {
//             accountHelpers.logout();
//           } else {
//             setError(Password change failed.' });
//           }
//         })
//         .catch((err) => {
//           if (err.response && err.response.status === 400) {
//             let fullMessage = 'Something went wrong!';
//             if (err.response.data && err.response.data.error && err.response.data.error.details && err.response.data.error.details.length) {
//               fullMessage = err.response.data.error.details.map(x => x.message.replace(/([a-z])([A-Z])/g, '$1 $2').concat('. '))[0];
//             }
//             setError(ullMessage });
//           } else if (err.response && err.response.data && err.response.data.message) {
//             setError(rr.response.data.message });
//           } else if (err) {
//             setError(Exception thrown!' });
//           }
//         });
//     }
//   }
//
//   render() {
//     const { loading } = this.props;
//     const { value, error } = this.state;
//
//     return (
//       <form className="form" onSubmit={this.handleSubmit}>
//         <img alt="SortPak" src="/sortpak-logo.png" className="logo" />
//         <h2 style={{ margin: '0px auto 30px auto', width: 'auto' }}>Change Password</h2>
//
//         <InputField
//           placeholder="Old password"
//           name="password"
//           type="password"
//           value={this.state.oldPassword}
//           onChange={oldPassword => this.setState({ oldPassword })}
//           className="w-100"
//           style={{ marginBottom: 10 }} />
//
//         <InputField
//           placeholder="New password"
//           name="password"
//           type="password"
//           value={this.state.password}
//           onChange={password => this.setState({ password })}
//           className="w-100"
//           style={{ marginBottom: 10 }} />
//
//         {
//           this.state.password
//             ? <PasswordStrengthBar onChangeScore={score => this.setState({ passStrength: score })} password={this.state.password} minLength={8} />
//             : null
//         }
//
//         <InputField
//           placeholder="Confirm password"
//           name="confirmpw"
//           type="password"
//           value={this.state.confirmpw}
//           className="w-100"
//           onChange={confirmpw => this.setState({ confirmpw })} />
//
//         {/* <ErrorMessage error={error} /> */}
//
//         <Button
//           className="button"
//           type="submit"
//           title="Confirm"
//           inactive={loading}
//           style={{ display: 'block', margin: '25px auto 0px auto' }} />
//
//         {/* <Link to="login/reset-password">Reset Password</Link> */}
//       </form>
//     );
//   }
// }
//
// ChangePassword.propTypes = {
//   error: PropTypes.any,
//   loading: PropTypes.any,
// };
//
// ChangePassword.defaultProps = {
//   error: null,
//   loading: false,
// };
//
// export default ChangePassword;
